/**
 * Initialise
 */
$(document).ready(function() {
    $('#TotemForm_InvitationForm_Commission').on('change', function() {
        commissionChangeLogic('TotemForm_InvitationForm');
    });

    $('#TotemForm_InvitationForm_CommissionType').on('change', function() {
        if ($(this).val() == '*') {
            jQuery('#MaxCommissionMatch').show();
        } else {
            jQuery('#MaxCommissionMatch').hide();
        }

        commissionChangeLogic('TotemForm_InvitationForm');
    });

    $('#TotemForm_InvitationForm .totemtabsetbs4').hide();
    $('.toBeHidden').each(function() {
        $(this).hide();
    });

    $('#TotemForm_InvitationForm_HasAcceptedTotemAffiliateProgram').on('click', function() {
        $('#TotemForm_InvitationForm .totemtabsetbs4').toggle();
        $('.toBeHidden').each(function() {
            $(this).toggle();
        });
    });

    //if it's already checked/ticked on load; trigger the toggle method to display it
    if ($('#TotemForm_InvitationForm_HasAcceptedTotemAffiliateProgram').prop('checked')) {
        $('#TotemForm_InvitationForm .totemtabsetbs4').toggle();
        $('.toBeHidden').each(function() {
            $(this).toggle();
        });
    }

    $('#TotemForm_InvitationForm_CountryGeoIDAffiliate').change(function() {
        var val = this.value;
        $.ajax({
            url: '/affiliate/statesjson',
            data: {
                country: val
            },
            type: 'GET',
            success: function(data) {
                var responseJSON = jQuery.parseJSON(data);
                $('#TotemForm_InvitationForm_StateGeoIDAffiliate').html(responseJSON.html);
            },
            error: function(data) {}
        });
    });
});
